<template>
  <div id="tab2" class="tab-panel">
    <div class="row">
      <div class="col-md-12">
        <!-- Main Form -->
        <div class="login-form-1">
          <form id="login-form-2" action="#">
            <h3 class="text-center no-margin-top">Завершение регистрации</h3>
            <p class="mar-bot-25 text-center">
              Укажи свое имя, фамилию и загрузи фото
            </p>
            <div class="main-login-form text-left">
              <div class="login-group">
                <div class="image-uploader">
                  <input
                    @change="uploadUserImage"
                    ref="import_file"
                    type="file"
                  />
                  <img v-if="!data.image" src="/default_image.png" />
                  <img :src="$IMAGE(data.image)" v-else />
                </div>
                <div class="form-group">
                  <input
                    disabled
                    :value="data.email"
                    name="email"
                    type="email"
                    class="form-control"
                    id="lg_password"
                    placeholder="Email"
                  />
                </div>
                <div class="form-group">
                  <input
                    @input="keypress"
                    :value="data.first_name"
                    name="first_name"
                    type="email"
                    class="form-control"
                    autocomplete="off"
                    id="lg_password"
                    placeholder="Имя"
                  />
                </div>
                <div class="form-group">
                  <input
                    @input="keypress"
                    :value="data.last_name"
                    name="last_name"
                    type="email"
                    class="form-control"
                    autocomplete="off"
                    id="lg_password"
                    placeholder="Фамилия"
                  />
                </div>
              </div>
              <button
                v-if="!loading"
                @click="completeUserAuth"
                type="button"
                class="login-button"
              >
                <i class="fa fa-chevron-right"></i>
              </button>
            </div>
            <div class="etc-login-form text-center text-main">
              <p @click="logout" class="mar-top-15 no-margin-bottom">
                <a><b>Другой аккаунт</b></a>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  props: ["loading"],
  computed: {
    ...mapState("user", ["data"]),
    ...mapState("app", ["auth"])
  },
  methods: {
    ...mapActions("app", ["authCheckHash", "uploadFile"]),
    ...mapActions("user", [
      "restoreUserPassword",
      "addUserData",
      "completeUserAuth",
      "logout"
    ]),
    addData(name, value) {
      const pseudoEvent = {
        target: {
          name,
          value
        }
      };
      this.$emit("handleInput", pseudoEvent);
    },
    keypress(ev) {
      this.$emit("handleInput", ev);
    },

    async uploadUserImage() {
      const files = this.$refs.import_file.files;
      const [formData] = await this.$processFileUpload(
        files,
        ["png", "jpg", "jpeg"],
        true,
        "avatars"
      );
      const uploadedFiles = await this.uploadFile(formData);

      this.addUserData({ name: "image", value: uploadedFiles[0] });
      this.addData("image", uploadedFiles[0]);
    }
  },
  mounted() {
    const { token, image, first_name, last_name } = this.data;

    if (!token) this.$router.push({ name: "auth" });

    if (image) this.addData("image", image);
    if (first_name) this.addData("first_name", first_name);
    if (last_name) this.addData("last_name", last_name);

    if (image && first_name && last_name) this.$router.push({ name: "feed" });
  }
};
</script>
